export default "__VITE_ASSET__EdHLfzFe__"